<template>
    <v-card style="background-color: #efeded">
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-icon @click="dialog = true" color="primary">mdi-brush-outline</v-icon>
                </v-col>
            </v-row>
            <v-row>
                <!-- Radar Chart -->
                <v-col cols="12" md="6">
                    <div style="width:70%; margin:0 auto">
                        <radar-chart v-if="isFontLoaded" :data="chartData" :chart-options="chartOptions" ref="radarChart" />
                    </div>
                </v-col>

                <!-- Data Table -->
                <v-col cols="12" md="6">
                    <v-data-table :headers="headers" style="background-color:transparent" :items="items" class="elevation-0 spidertable" dense>
                    </v-data-table>
                </v-col>
            </v-row>

            <v-dialog v-model="dialog" persistent max-width="700px">
                <v-card>
                    <div class="card-title">
                        {{ $t('ChangeColor') }}
                    </div>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-color-picker v-model="colorTwo" mode="hexa"></v-color-picker>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-color-picker v-model="colorOne" mode="hexa"></v-color-picker>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false" text>{{ $t('Close') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </v-card>
</template>

<script>
    import { Radar } from 'vue-chartjs'
    import { Chart as ChartJS, Title, Tooltip, Legend, RadialLinearScale, PointElement, LineElement, Filler, defaults } from 'chart.js'

    ChartJS.register(Title, Tooltip, Legend, RadialLinearScale, PointElement, LineElement, Filler)

    export default {
        components: {
            RadarChart: Radar
        },
        props: {
            value: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                isFontLoaded: true,
                chartData: {
                    labels: [], // Dynamic labels
                    datasets: []
                },
                colorOne: '#70A889',
                colorTwo: '#ff6384',
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: true,
                    layout: {
                        padding: 20 // ✅ Ensures labels are not cut off
                    },
                    plugins: {
                        legend: {
                            position: 'bottom',
                            labels: {
                                font: { size: 18, weight: 'bold' },
                                color: '#333'
                            }
                        },
                        title: {
                            display: true,
                            text: 'مقارنة بين معدل الرضا ومعدل الانتشار',
                            font: { size: 24, weight: 'bold' },
                            color: '#000'
                        }
                    },
                    scales: {
                        r: {
                            angleLines: { color: '#ddd' },
                            grid: { color: '#eee' },
                            pointLabels: {
                                display: true, // ✅ Ensures category labels show
                                font: { size: 18, weight: 'bold' },
                                color: '#000' // ✅ Ensures labels are visible
                            },
                            ticks: {
                                display: true,
                                backdropColor: 'transparent',
                                font: { size: 14 },
                                color: '#666'
                            }
                        }
                    }
                },
                headers: [
                    { text: 'المحاور الرئيسية', value: 'category' },
                    { text: 'معدل الرضا عن الجهود', value: 'satisfaction' },
                    { text: 'معدل الانتشار', value: 'prevalence' },
                    { text: 'حجم الفجوة', value: 'gap' }
                ],
                items: [],
                dialog: false
            }
        },
        methods: {
            processData() {
                const groupedData = this.value.reduce((acc, item) => {
                    const category = item.id.split('_')[0]
                    const type = item.id.split('_')[1]

                    if (!acc[category]) {
                        acc[category] = { satisfaction: 0, prevalence: 0 }
                    }

                    if (type === 'الرضا') {
                        acc[category].satisfaction += item.percentage
                    } else if (type === 'الانتشار') {
                        acc[category].prevalence += item.percentage
                    }

                    return acc
                }, {})

                const categories = Object.keys(groupedData)
                const satisfactionData = []
                const prevalenceData = []

                this.items = categories.map((category) => {
                    const { satisfaction, prevalence } = groupedData[category]
                    const gap = Math.abs(satisfaction - prevalence)

                    satisfactionData.push(satisfaction)
                    prevalenceData.push(prevalence)

                    return {
                        category,
                        satisfaction: `${satisfaction}%`,
                        prevalence: `${prevalence}%`,
                        gap: `${gap}%`
                    }
                })

                this.chartData = {
                    labels: categories, // ✅ Assign category labels
                    datasets: [
                        {
                            label: 'معدل الرضا عن الجهود',
                            data: satisfactionData,
                            backgroundColor: this.colorOne + '20',
                            borderColor: this.colorOne,
                            borderWidth: 2,
                            pointBackgroundColor: this.colorOne
                        },
                        {
                            label: 'معدل انتشار مظاهر التشوه',
                            data: prevalenceData,
                            backgroundColor: this.colorTwo + '20',
                            borderColor: this.colorTwo,
                            borderWidth: 2,
                            pointBackgroundColor: this.colorTwo
                        }
                    ]
                }

                this.$nextTick(() => {
                    if (this.$refs.radarChart?.update) {
                        this.$refs.radarChart.update()
                    }
                })
            }

        },
        watch: {
            value: {
                immediate: true,
                handler() {
                    this.processData()
                }
            },
            colorOne: 'processData',
            colorTwo: 'processData'
        },
        mounted() {
            defaults.font.family = 'TheSansArabic'
            defaults.color = 'black'
        }
    }
</script>
<style>
    canvas {
        max-width: 100% !important;
        max-height: 100% !important;
    }

    .spidertable {
        font-size: 16px !important;
        color: black !important;
    }

    .v-data-table {
        background-color: transparent !important;
    }

    .v-card {
        overflow: visible !important;
    }

</style>